export type ApiError = {
  error?: {
    code: string;
    message: string;
  };
};

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "/internal";

export function apiUrl(path: string) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalized}`;
}

export async function apiFetch<T>(
  path: string,
  getToken: () => Promise<string | null>,
  init: RequestInit = {}
) {
  const token = await getToken();
  const headers = new Headers(init.headers);

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  if (init.body && !(init.body instanceof FormData) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const response = await fetch(apiUrl(path), { ...init, headers });

  if (!response.ok) {
    let message = `Request failed with ${response.status}`;
    try {
      const payload = (await response.json()) as ApiError;
      message = payload.error?.message ?? message;
    } catch {
      // Keep the status-based fallback.
    }
    throw new Error(message);
  }

  return (await response.json()) as T;
}

export function currency(amount: number, code = "usd") {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: code.toUpperCase()
  }).format(amount / 100);
}

export function readableStatus(value: string) {
  return value.replaceAll("_", " ").replaceAll(".", " ");
}
